module.exports = __webpack_public_path__ + "img/Lei_Li.13481f6.png";